import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'projects/environments/environment';

function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

function isNumber(value: any): boolean {
    return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbDateParserFormat extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        //console.log('NgbDateParserFormat parse' , value);
        if (value) {
            const dateParts = value.trim().split('/');
            //console.log('dateParts',dateParts);
            if (dateParts.length === 1 && isNumber(dateParts[0])) {
                return { year: toInteger(dateParts[0]), month: null, day: null };
            } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
                return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: null };
            } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
                return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2]) };
            }
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        //console.log('NgbDateParserFormat format' , date);
        let stringDate: string = "";
        if (date) {
            let datePipe = new DatePipe('en-US');
            stringDate = datePipe.transform(new Date(date.year, date.month -1, date.day), environment.DateFormat);
            // stringDate += isNumber(date.day) ? padNumber(date.day) + "/" : "";
            // stringDate += isNumber(date.month) ? padNumber(date.month) + "/" : "";
            // stringDate += date.year;
        }
        return stringDate;
    }
}